import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import { Label, H3, Body } from 'components/styled/typography'
import { connect } from 'react-redux'
import { LocalForm } from 'react-redux-form'
import { mapLanguageToComponentProps } from 'interview/i18n'
import AdditionalField from 'components/additional-field'
import FormErrors from 'components/form-components/form-errors'
import find from 'lodash/fp/find'

const propTypes = {
  additionalFormFields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      fieldSetup: PropTypes.shape({
        required: PropTypes.bool.isRequired,
        visible: PropTypes.bool.isRequired,
      }),
    })
  ).isRequired,
  responses: PropTypes.arrayOf(
    PropTypes.shape({
      fieldId: PropTypes.string,
      answer: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    })
  ).isRequired,
  changeAction: PropTypes.func.isRequired,
  isFormValid: PropTypes.func,
  noValidation: PropTypes.bool,
  legend: PropTypes.string,
  requiredText: PropTypes.string,
}

const defaultProps = {
  isFormValid: undefined,
  noValidation: false,
  legend: undefined,
  requiredText: undefined,
}

const StyledForm = styled.div`
  margin: ${({ theme }) => theme.space.s16} 0;
`

const FieldContainer = styled.div`
  margin: ${({ theme }) => theme.space.s16} 0;
`

export class AdditionalFieldsForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      newSubmit: false,
    }
  }

  onChangeAdditionalField(value, field) {
    const { changeAction } = this.props
    if (value && value.length > 0) {
      changeAction('additionalFieldResponse', {
        fieldId: field._id,
        answer: value,
      })
    } else {
      changeAction('additionalFieldResponse', { fieldId: field._id })
    }
  }

  onUpdate(values) {
    const { isFormValid } = this.props
    const { newSubmit } = this.state
    const { $form, ...fields } = values
    Object.keys(fields).forEach(key => {
      fields[key] = fields[key].$form
        ? { ...fields[key].$form, model: `additionalFields.${key}` }
        : fields[key]
    })

    if (!$form.valid && newSubmit) {
      const field =
        find({ valid: false })(fields) ||
        this.findNestedInvalidForm(values.fields)
      const model = field.model && field.model.split('.')[1]
      const element =
        document.querySelector(`[name="${model}"]`) ||
        document.getElementById(model)
      if (element) {
        element.scrollIntoView()
      }

      // Reset submit state or scroll will happen always.
      this.setState({ newSubmit: false })
    }
    if (isFormValid) {
      isFormValid(fields)
    }
  }

  onSubmitFailed() {
    this.setState({ newSubmit: true })
  }

  getInitialValue() {
    const { additionalFormFields, responses } = this.props
    const result = {}

    additionalFormFields.forEach(field => {
      const savedField =
        responses && responses.find(response => response.fieldId === field._id)
      result[field._id] = (savedField && savedField.answer) || ''
    })
    return result
  }

  renderFields() {
    const { additionalFormFields, noValidation, responses } = this.props

    return (
      <>
        {additionalFormFields.map(field => {
          const FieldByType = AdditionalField[field.type]
          const response = responses.find(
            response => response.fieldId === field._id
          )

          return (
            <FieldContainer key={field._id}>
              <Label htmlFor="answerfield" color="grey90">
                {field.label +
                  (field.fieldSetup.required && !noValidation ? '*' : '')}
              </Label>
              <FieldByType
                field={field}
                fieldResponse={response}
                noValidation={noValidation}
                onChange={value => this.onChangeAdditionalField(value, field)}
              />
              <FormErrors model={`.${field._id}`} />
            </FieldContainer>
          )
        })}
      </>
    )
  }

  render() {
    const { legend, requiredText } = this.props
    const initialValue = this.getInitialValue()
    return (
      <StyledForm>
        <H3>{legend}</H3>
        {requiredText && <Body>{requiredText}</Body>}
        <LocalForm
          model="additionalFields"
          name="additionalFieldsForm"
          initialState={initialValue}
          onUpdate={values => this.onUpdate(values)}
          onSubmitFailed={() => this.onSubmitFailed()}
        >
          {this.renderFields()}
        </LocalForm>
      </StyledForm>
    )
  }
}

AdditionalFieldsForm.propTypes = propTypes
AdditionalFieldsForm.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(AdditionalFieldsForm)
